import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(...registerables);
Chart.register(ChartDataLabels);

$(() => {
    const has_pc = window.matchMedia("(min-width: 768px)");

    const chart_sales_trends = document.querySelector("#chart-sales-trends");

    function func_chart_sales_trends() {
        new Chart(chart_sales_trends, {
            type: "bar",
            data: {
                labels: ["H26年度", "H27年度", "H28年度", "H29年度", "H30年度", "H31年度", "R2年度", "R3年度", "R4年度", "R5年度"],
                datasets: [
                    {
                        // label: '# of Votes',
                        barPercentage: 0.5,
                        data: [76.1, 71.9, 56, 61.7, 69, 76.1, 66.4, 69.5, 62.6, 63.6],
                        borderWidth: 0,
                        backgroundColor: "#87CE7D",
                        datalabels: {
                            // 月別気温(2019)のデータラベル設定
                            color: has_pc.matches ? "#fff" : "#000",
                            font: {
                                weight: "bold",
                            },
                            anchor: "end", // データラベルの位置（'end' は上端）
                            align: "start", // データラベルの位置（'end' は上側）
                            padding: {
                                bottom: 0,
                            },
                        },
                    },
                ],
            },
            options: {
                plugins: {
                    legend: {
                        display: false,
                    },
                    datalabels: {
                        font: {
                            // size: 14
                        },
                    },
                },
                scales: {
                    y: {
                        title: {
                            display: true,
                            text: "（億円）",
                        },
                        beginAtZero: true,
                    },
                },
            },
        });
    }

    if (chart_sales_trends) {
        $(window).on("load.chart1 scroll.chart1", function () {
            if (window.scrollY + window.innerHeight * 0.7 > $(".section-chart").eq(0).offset().top) {
                func_chart_sales_trends();
                $(window).off(".chart1");
            }
        });
    }

    const chart_number_employees = document.querySelector("#chart-number-employees");

    function func_chart_number_employees() {
        new Chart(chart_number_employees, {
            type: "bar",
            data: {
                labels: ["H26年度", "H27年度", "H28年度", "H29年度", "H30年度", "H31年度", "R2年度", "R3年度", "R4年度", "R5年度"],
                datasets: [
                    {
                        // label: '# of Votes',
                        barPercentage: 0.5,
                        data: [468, 453, 489, 667, 640, 623, 631, 609, 586, 562],
                        borderWidth: 0,
                        backgroundColor: "#89C0E3",
                        datalabels: {
                            // 月別気温(2019)のデータラベル設定
                            color: has_pc.matches ? "#fff" : "#000",
                            font: {
                                weight: "bold",
                            },
                            anchor: "end", // データラベルの位置（'end' は上端）
                            align: "start", // データラベルの位置（'end' は上側）
                            padding: {
                                bottom: 0,
                            },
                        },
                    },
                ],
            },
            options: {
                plugins: {
                    legend: {
                        display: false,
                    },
                    datalabels: {
                        font: {
                            // size: 14
                        },
                    },
                },
                scales: {
                    y: {
                        title: {
                            display: true,
                            text: "（人）",
                        },
                        beginAtZero: true,
                    },
                },
            },
        });
    }

    if (chart_number_employees) {
        $(window).on("load.chart2 scroll.chart2", function () {
            if (window.scrollY + window.innerHeight * 0.7 > $(".section-chart").eq(1).offset().top) {
                func_chart_number_employees();
                $(window).off(".chart2");
            }
        });
    }
});
